// Mock data for Manalogi landing page

export const translations = {
  id: {
    nav: {
      home: 'Beranda',
      about: 'Tentang',
      solutions: 'Solusi',
      products: 'Produk',
      clients: 'Klien',
      contact: 'Kontak',
      admin: 'Admin'
    },
    hero: {
      title: 'Partner Setia dalam Transformasi Digital',
      subtitle: 'Kami hadir untuk mendukung transformasi digital yang efektif, menyelesaikan masalah, dan meningkatkan manfaat sistem yang ada dalam organisasi Anda',
      cta: 'Hubungi Kami',
      downloadBrochure: 'Unduh Brosur'
    },
    about: {
      title: 'Siapa Kami?',
      description: 'Manalogi bertujuan menjadi mitra setia dalam mendukung transformasi digital yang efektif. Kami fokus untuk bersama-sama menyelesaikan pain point dan meningkatkan manfaat sistem yang sudah ada di dalam organisasi.'
    },
    whyChoose: {
      title: 'Mengapa Memilih Manalogi?',
      items: [
        {
          title: 'Dipercaya',
          description: 'Dipercaya oleh berbagai institusi terkemuka, bank, dan industri'
        },
        {
          title: 'Berpengalaman',
          description: 'Berpengalaman dalam mengembangkan produk/solusi untuk use case perbankan dan non-perbankan'
        },
        {
          title: 'Kemampuan End-to-End',
          description: 'Menawarkan layanan komprehensif dari konsultasi hingga dukungan purna jual'
        }
      ]
    },
    solutions: {
      title: 'Portfolio Solusi',
      items: [
        {
          title: 'Manalogi Digital Tech Dev',
          description: 'Menggunakan teknologi dan integrasi yang visioner untuk memberikan solusi aplikasi mobile/web yang disesuaikan, intuitif, dan mudah digunakan'
        },
        {
          title: 'Manalogi System Integra',
          description: 'Memungkinkan model bisnis baru tanpa perlu mengganti sistem yang ada, memungkinkan bisnis bertransformasi dan meluncurkan proyek baru dengan cepat'
        },
        {
          title: 'Manalogi Consulting & Training',
          description: 'Menawarkan layanan konsultasi dan pelatihan untuk mendukung transformasi organisasi, bisnis, dan digital guna meningkatkan kualitas perusahaan'
        }
      ]
    },
    products: {
      bfsi: {
        title: 'Portfolio Produk BFSI',
        subtitle: 'Banking, Financial Services, and Insurance'
      },
      industry: {
        title: 'Portfolio Produk Industri Lainnya',
        subtitle: 'Solusi untuk berbagai vertikal industri'
      }
    },
    clients: {
      title: 'Dipercaya Oleh',
      subtitle: 'Berbagai institusi terkemuka mempercayai solusi kami'
    },
    contact: {
      title: 'Mari Berdiskusi',
      subtitle: 'Hubungi kami untuk mengetahui lebih lanjut tentang solusi kami',
      form: {
        name: 'Nama',
        email: 'Email',
        company: 'Perusahaan',
        message: 'Pesan',
        submit: 'Kirim Pesan',
        success: 'Pesan berhasil dikirim!',
        error: 'Gagal mengirim pesan. Silakan coba lagi.'
      },
      info: {
        email: 'halo@manalogi.com',
        website: 'manalogi.com'
      }
    },
    footer: {
      company: 'PT Manunggal Laju Teknologi',
      rights: 'Hak Cipta Dilindungi',
      links: {
        about: 'Tentang Kami',
        solutions: 'Solusi',
        products: 'Produk',
        contact: 'Kontak'
      }
    },
    chat: {
      title: 'Chat dengan Kami',
      placeholder: 'Ketik pesan Anda...',
      send: 'Kirim',
      minimize: 'Minimize',
      offline: 'Kami sedang offline. Silakan tinggalkan pesan.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      solutions: 'Solutions',
      products: 'Products',
      clients: 'Clients',
      contact: 'Contact',
      admin: 'Admin'
    },
    hero: {
      title: 'Your Loyal Partner in Digital Transformation',
      subtitle: 'We are here to support effective digital transformation, solve problems, and increase the benefits of existing systems within your organization',
      cta: 'Contact Us',
      downloadBrochure: 'Download Brochure'
    },
    about: {
      title: 'Who We Are?',
      description: 'Manalogi aims to be a loyal partner in supporting effective digital transformation. We focus on jointly solving pain points and increasing the benefits of existing systems within organizations.'
    },
    whyChoose: {
      title: 'Why Choose Manalogi?',
      items: [
        {
          title: 'Trusted',
          description: 'Trusted by various leading institutions, banks, and industries'
        },
        {
          title: 'Experienced',
          description: 'Experienced in developing products/solutions for banking and non-banking use cases'
        },
        {
          title: 'End-to-End Capabilities',
          description: 'Offers comprehensive services from consultancy to after-sales support'
        }
      ]
    },
    solutions: {
      title: 'Solution Portfolio',
      items: [
        {
          title: 'Manalogi Digital Tech Dev',
          description: 'Employs vision-forward technologies and integrations to deliver intuitive and usable customized mobile/web app solutions'
        },
        {
          title: 'Manalogi System Integra',
          description: 'Enables new business models without needing to rip/replace existing systems, allowing businesses to transform themselves and quickly roll out new projects'
        },
        {
          title: 'Manalogi Consulting & Training',
          description: 'Offers consulting and training services to support organizational, business, and digital transformation to improve company quality'
        }
      ]
    },
    products: {
      bfsi: {
        title: 'BFSI Product Portfolio',
        subtitle: 'Banking, Financial Services, and Insurance'
      },
      industry: {
        title: 'Various Industry Product Portfolio',
        subtitle: 'Solutions for various industry verticals'
      }
    },
    clients: {
      title: 'Trusted By',
      subtitle: 'Leading institutions trust our solutions'
    },
    contact: {
      title: "Let's Discuss",
      subtitle: 'Contact us to learn more about our solutions',
      form: {
        name: 'Name',
        email: 'Email',
        company: 'Company',
        message: 'Message',
        submit: 'Send Message',
        success: 'Message sent successfully!',
        error: 'Failed to send message. Please try again.'
      },
      info: {
        email: 'halo@manalogi.com',
        website: 'manalogi.com'
      }
    },
    footer: {
      company: 'PT Manunggal Laju Teknologi',
      rights: 'All Rights Reserved',
      links: {
        about: 'About Us',
        solutions: 'Solutions',
        products: 'Products',
        contact: 'Contact'
      }
    },
    chat: {
      title: 'Chat with Us',
      placeholder: 'Type your message...',
      send: 'Send',
      minimize: 'Minimize',
      offline: 'We are offline. Please leave a message.'
    }
  }
};

export const bfsiProducts = [
  {
    id: '1',
    name_id: 'Sistem Onboarding Nasabah',
    name_en: 'Customer on-Boarding System',
    description_id: 'Sepenuhnya mendigitalkan dan merampingkan proses onboarding untuk nasabah korporat dan individu, meningkatkan efisiensi dan memperkuat kepatuhan',
    description_en: 'Fully digitizes and streamlines the onboarding process for both corporate and individual customers, improving efficiency and strengthening compliance',
    icon: 'user-plus',
    features: [
      { id: 1, text_id: 'Verifikasi identitas digital real-time', text_en: 'Real-time digital identity verification' },
      { id: 2, text_id: 'Proses paperless end-to-end', text_en: 'End-to-end paperless process' },
      { id: 3, text_id: 'Integrasi dengan sistem KYC', text_en: 'KYC system integration' },
      { id: 4, text_id: 'E-signature untuk dokumen', text_en: 'E-signature for documents' },
      { id: 5, text_id: 'Dashboard monitoring real-time', text_en: 'Real-time monitoring dashboard' },
      { id: 6, text_id: 'Compliance automation', text_en: 'Compliance automation' }
    ],
    benefits: [
      { id: 1, text_id: 'Mengurangi waktu onboarding hingga 70%', text_en: 'Reduce onboarding time by up to 70%' },
      { id: 2, text_id: 'Meningkatkan akurasi data nasabah', text_en: 'Improve customer data accuracy' },
      { id: 3, text_id: 'Mengurangi biaya operasional', text_en: 'Reduce operational costs' },
      { id: 4, text_id: 'Meningkatkan compliance regulasi', text_en: 'Improve regulatory compliance' }
    ],
    technical_specs: {
      platform: 'Web & Mobile',
      deployment: 'Cloud / On-Premise',
      technology: 'React, Node.js, MongoDB',
      security: 'ISO 27001 Certified',
      support: '24/7 Technical Support',
      updates: 'Free Forever'
    }
  },
  {
    id: '2',
    name_id: 'Sistem Mobile Banking',
    name_en: 'Mobile Banking System',
    description_id: 'Meningkatkan ROI dan loyalitas nasabah, mengurangi biaya operasional dan layanan pelanggan dengan aplikasi mobile banking yang canggih, aman, dan nyaman',
    description_en: 'Increases ROI and customer loyalty, reduces operational and customer service costs with a sophisticated, secure, and convenient mobile banking app',
    icon: 'smartphone',
    image_url: localStorage.getItem('product_2_image') || '',
    brochure_url: localStorage.getItem('product_2_brochure') || '',
    brochure_name: localStorage.getItem('product_2_brochure_name') || '',
    features: [
      { id: 1, text_id: 'Interface yang user-friendly dan mudah digunakan', text_en: 'User-friendly and easy-to-use interface' },
      { id: 2, text_id: 'Keamanan data tingkat enterprise', text_en: 'Enterprise-level data security' },
      { id: 3, text_id: 'Integrasi seamless dengan sistem existing', text_en: 'Seamless integration with existing systems' },
      { id: 4, text_id: 'Push notification real-time', text_en: 'Real-time push notifications' },
      { id: 5, text_id: 'Biometric authentication', text_en: 'Biometric authentication' },
      { id: 6, text_id: 'Multi-currency support', text_en: 'Multi-currency support' }
    ],
    benefits: [
      { id: 1, text_id: 'Meningkatkan engagement nasabah hingga 60%', text_en: 'Increase customer engagement up to 60%' },
      { id: 2, text_id: 'Mengurangi beban call center', text_en: 'Reduce call center workload' },
      { id: 3, text_id: 'Meningkatkan transaksi digital', text_en: 'Increase digital transactions' },
      { id: 4, text_id: 'Meningkatkan kepuasan pelanggan', text_en: 'Improve customer satisfaction' }
    ],
    technical_specs: {
      platform: 'iOS & Android',
      deployment: 'Cloud-based',
      technology: 'React Native, Java Spring Boot',
      security: 'PCI-DSS Compliant',
      support: '24/7 Technical Support',
      updates: 'Regular Updates'
    }
  },
  {
    id: '3',
    name_id: 'Sistem Pembayaran Cashless',
    name_en: 'Cashless Payment System',
    description_id: 'Sistem pembayaran cashless (aplikasi dan hardware) yang dapat mendukung berbagai sumber dana',
    description_en: 'A cashless payment system (application and hardware) that can support multiple sources of funds',
    icon: 'credit-card'
  },
  {
    id: '4',
    name_id: 'Sistem Kredit Mikro',
    name_en: 'Micro Credit System',
    description_id: 'Memungkinkan nasabah bank untuk mengajukan pinjaman mikro, menyederhanakan, mengotomatisasi, dan mendigitalkan proses pencairan kredit',
    description_en: 'Allows bank customers to apply for microloans, simplifying, automating, and digitizing the process for disbursing credit loans',
    icon: 'coins'
  },
  {
    id: '5',
    name_id: 'Sistem e-Commerce',
    name_en: 'e-Commerce System',
    description_id: 'Teknologi e-commerce canggih yang menyederhanakan dan meningkatkan penanganan seluruh perjalanan pelanggan, dari pra-pembelian hingga pasca-pembelian',
    description_en: 'State-of-the-art e-commerce technology that simplifies and enhances handling the entire customer journey, from pre-purchase to post-purchase',
    icon: 'shopping-cart'
  },
  {
    id: '6',
    name_id: 'Sistem Digital Wallet',
    name_en: 'Digital Wallet System',
    description_id: 'Memungkinkan nasabah melakukan pembayaran di toko, online, dan dalam aplikasi. Menyimpan kartu debit & kredit, serta kartu hadiah dan kupon diskon secara digital',
    description_en: 'Enables customers to make in-store, online, and in-app payments. Digitally stores debit & credit cards, as well as gift cards and discount coupons',
    icon: 'wallet'
  },
  {
    id: '7',
    name_id: 'Sistem Laku Pandai/Agen',
    name_en: 'Laku Pandai/Agency System',
    description_id: 'Memfasilitasi layanan keuangan perbankan tanpa kantor melalui kolaborasi dengan pihak lain (agen bank), berdasarkan teknologi digital canggih sesuai program keuangan inklusif OJK',
    description_en: 'Facilitates office-less banking financial services through collaboration with other parties (bank agents), based on state-of-the-art digital technology aligned with OJK inclusive financial programs',
    icon: 'building-2'
  },
  {
    id: '8',
    name_id: 'Sistem Loyalty Point',
    name_en: 'Loyalty Point System',
    description_id: 'Sistem loyalitas yang menghitung poin berdasarkan nilai transaksi, jenis kartu, dan merchant, dengan opsi penukaran poin via EDC',
    description_en: 'A loyalty system that calculates points based on transaction value, card type, and merchant, with options for redeeming points via EDC',
    icon: 'gift'
  }
];

export const industryProducts = [
  {
    id: '9',
    name_id: 'Sistem Manajemen Pengunjung',
    name_en: 'Visitor Management System',
    description_id: 'Aplikasi manajemen pengunjung dilengkapi sistem barcode yang mencatat waktu check-in/check-out, tujuan kunjungan, dan informasi pengunjung',
    description_en: 'A visitor management application equipped with a barcode system that records check-in/check-out times, purpose of visit, and visitor information',
    icon: 'users'
  },
  {
    id: '10',
    name_id: 'Sistem Manajemen Tenant',
    name_en: 'Tenant Management System',
    description_id: 'Memfasilitasi kebutuhan tenant dalam satu aplikasi, termasuk penanganan keluhan, billing, belanja kebutuhan, tombol panic darurat, dan media informasi',
    description_en: 'Facilitates tenant needs in a single app, including complaint handling, billing, groceries, emergency panic buttons, and information media',
    icon: 'home'
  },
  {
    id: '11',
    name_id: 'Sistem Smart Guard Tour',
    name_en: 'Smart Guard Tour System',
    description_id: 'Sistem manajemen patroli untuk membuat rute patroli, menugaskan penjaga, melacak dan memantau patroli penjaga, menangani laporan darurat, dan integrasi dengan sistem CCTV',
    description_en: 'A patrol management system to create patrol routes, assign guards, track and monitor guard patrols, handle emergency reports, and integrate with CCTV systems',
    icon: 'shield-check'
  },
  {
    id: '12',
    name_id: 'Sistem Manajemen Fasilitas',
    name_en: 'Facility Management System',
    description_id: 'Sistem manajemen fasilitas lengkap untuk work order, manajemen peralatan, manajemen material, dan penjadwalan pemeliharaan untuk merampingkan operasi',
    description_en: 'A full-featured facility management system for work orders, equipment management, material management, and maintenance scheduling to streamline operations',
    icon: 'wrench'
  },
  {
    id: '13',
    name_id: 'Sistem Manajemen Housekeeping',
    name_en: 'Housekeeping Management System',
    description_id: 'Mengelola operasi harian housekeeping melalui sistem dashboard tunggal, termasuk manajemen work order, checklist, dan laporan',
    description_en: 'Manages housekeeping daily operations via a single dashboard system, including work order management, checklists, and reports',
    icon: 'sparkles'
  },
  {
    id: '14',
    name_id: 'Sistem Pemesanan Ruangan',
    name_en: 'Room Booking System',
    description_id: 'Menyederhanakan pemesanan ruangan untuk admin dan pengguna dengan fitur penjadwalan, undangan, pemesanan di lokasi, pemesanan fasilitas, deployment fleksibel, dan add-ons',
    description_en: 'Simplifies room booking for both admin and users with features for scheduling, invitations, on-site booking, order facilities, flexible deployment, and add-ons',
    icon: 'calendar'
  }
];

export const clients = [
  { id: '1', name: 'CSI VisioNet', logo: 'https://via.placeholder.com/150x60?text=CSI+VisioNet' },
  { id: '2', name: 'Bank Kaltimtara', logo: 'https://via.placeholder.com/150x60?text=Bank+Kaltimtara' },
  { id: '3', name: 'Bank BJB', logo: 'https://via.placeholder.com/150x60?text=Bank+BJB' },
  { id: '4', name: 'Bank BTN', logo: 'https://via.placeholder.com/150x60?text=Bank+BTN' },
  { id: '5', name: 'Bank BRI', logo: 'https://via.placeholder.com/150x60?text=Bank+BRI' },
  { id: '6', name: 'WIDE', logo: 'https://via.placeholder.com/150x60?text=WIDE' },
  { id: '7', name: 'GMF AeroAsia', logo: 'https://via.placeholder.com/150x60?text=GMF+AeroAsia' },
  { id: '8', name: 'PATRAJASA', logo: 'https://via.placeholder.com/150x60?text=PATRAJASA' }
];

export const capabilities = [
  'Product and Solution Consultancy',
  'Planning and Design',
  'Product and Project Management',
  'Development and Delivery',
  'System and Network Integration',
  'Testing and Commissioning',
  'Deployment and Implementation',
  'Transfer of Knowledge and Training',
  'Technical Support and Maintenance'
];

export const siteSettings = {
  logo_url: localStorage.getItem('site_logo_url') || '',
  favicon_url: localStorage.getItem('site_favicon_url') || '',
  company_name: localStorage.getItem('site_company_name') || 'manalogi',
  contact_email: 'halo@manalogi.com',
  contact_website: 'manalogi.com'
};
